<template>
    <div v-if="isVisible" :class="backdropName">        
        <div :class="wrapperName" tabindex="0">
        <div class="container-fluid g-1">    
            <localization :language="'de-DE'">
                <intl :locale="'de'">
                    <div class="row row-cols-auto row_gap left__page-edge">
                        <div class="col-12" style="margin-top: 10px;">
                            <h5 class="form__header">{{ getPasswordTitle() }}</h5>
                        </div>
                    </div>
                    <div class="row row-cols-auto row_gap left__page-edge align-items-start">
                        <div class="col-12" style="margin-top: 10px;">
                            <label style="font-size: 12px; text-align: left; padding-left: 8px; padding-right: 8px;">Das Kennwort muss mindestens 8 Zeichen lang sein und mindestens eine Ziffer, einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen (! @ # $ % ^ & * _ ? -) enthalten.</label>
                        </div>
                    </div>
                    <form class="k-form wrapper__content">
                        <!--++----------------------- row 1 -------------------------------++-->                
                        <div v-if="mode === 'change' && !isAdminMode" class="row row-cols-auto row_gap left__page-edge align-items-end" >
                            <!--+    col 1    +-->
                            <div class="col-12">
                                <k-input 
                                        type="password" label="Aktuelles Kennwort" autocomplete="off" 
                                        :style="{width: '100%'}"        
                                        :tabIndex="1"                                                                           
                                        :show-validation-icon="false" 
                                        v-model="passwordRef.data.kennwort"     
                                        @paste.prevent                         
                                />
                            </div>
                        </div>
                    <!--++----------------------- row 2 -------------------------------++-->                
                    <div class="row row-cols-auto row_gap left__page-edge align-items-end"  style="min-height: 64px!important"  >
                            <!--+    col 1    +-->
                            <div class="col-12">
                                <k-input 
                                        type="password" label="Neues Kennwort" autocomplete="off" 
                                        :style="{width: '100%'}"        
                                        :tabIndex="1"                                                                           
                                        :show-validation-icon="false"  
                                        v-model="passwordRef.data.kennwortNeu"     
                                        @paste.prevent                            
                                />
                            </div>
                        </div>
                    <!--++----------------------- row 3 -------------------------------++-->                
                    <div class="row row-cols-auto row_gap left__page-edge align-items-end" style="min-height: 64px!important" >
                            <!--+    col 1    +-->
                            <div class="col-12">
                                <k-input 
                                        type="password" label="Bestätigung Kennwort" autocomplete="off" 
                                        :style="{width: '100%'}"        
                                        :tabIndex="1"                                                                           
                                        :show-validation-icon="false"  
                                        v-model="passwordRef.data.kennwortVergleich"       
                                        @paste.prevent                        
                                />

                            </div>
                    </div>

                    <div style="height: 42px;" /> 
                    <div class="row row-cols-auto justify-content-end button__dist">
                        <div class="col save__min-width left__button">
                           
                            <div style="display: inline-block;">
                                <kbutton @click.prevent="onPasswordCancel" :icon="'cancel'" :theme-color="'primary'" :size="'medium'" :class="'save__size'">Abbrechen</kbutton>
                            </div>
                            <div style="display: inline-block; width: 22px;" />
                            <div style="display: inline-block;">
                                <kbutton @click.prevent="onPasswordChange"  :icon="'save'" :theme-color="'primary'" :size="'medium'" :class="'save__size'">{{getPasswordTitle()}}</kbutton>
                            </div>

                        </div>
                    </div>

                    



                    </form>
                </intl>
            </localization>
        </div>
    </div>
    </div>
</template>

<script lang="ts">   
    import { defineComponent, reactive, ref, watch } from 'vue';
    import DataComboBox from "@/components/shared/ComboBoxBase/DataComboBox.vue"
    import { Input  } from '@progress/kendo-vue-inputs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { Editor } from "@progress/kendo-vue-editor";    
    import { IntlProvider, LocalizationProvider } from '@progress/kendo-vue-intl';
    
    
    import { CreateUserError, ErrorStateServiceForRoot } from '@/infrastructure/observables/errorState';
    import { Identity } from "@/infrastructure/backend/userIdentity";
    import { ChangePasswordData, KennwortVerwaltung } from './interfaces/kennwortVerwaltung';

    
    export default defineComponent ({
        name: "KennwortAendern",  
        components: {    
            DataComboBox,
            'k-input': Input,
            'kbutton': Button,
            'intl': IntlProvider,
            'localization': LocalizationProvider,
            Editor
    
        },
        inheritAttrs: false,
        emits: {
            passwordChanged: (success: boolean) => success,            
        },
        props: {
            idPerson: {
                type: Number,
                default: null,      
                require: false,            
            },
            isVisible: {
                type: Boolean,
                default: true,
                require: false,
            },
            // dialog__wrapper, form__wrapper
            className: {
                type: String,
                default: "dialog__wrapper",
                require: false,
            },	
            refresh: {
                type: Date,
                default: new Date(),
                require: false
            },
            // new, change
            mode: {
                type: String,
                default: "new",
                require: false
            },
            isAdminMode: {
                type: Boolean,
                default: false,
                require: false
            }

        },
        setup(props, { emit }) {

            const idPerson = ref<number>(props.idPerson);
            let passwordData: ChangePasswordData = {
                id: idPerson.value,
                kennwort: "",
                kennwortNeu: "",
                kennwortVergleich: "",
                userId: Identity.getIdentity().getValue().UserId
            };

            const passwordRef = reactive({
                data: passwordData
            })


            const isVisible = ref<boolean>(props.isVisible);
            const wrapperName = ref<string>(props.className);
            const backdropName = ref<string>("backdrop-none");
            const mode = ref<string>(props.mode);
            const isAdminMode = ref<boolean>(props.isAdminMode);


            if (props.className === "dialog__wrapper") {
                backdropName.value = "backdrop";
            }


            function onPasswordCancel() {
                cancelPassword()              
            }


            function onPasswordChange() {
                if ( !handlePasswordChange()) return;
                savePassword()
            }

            function handlePasswordChange() : boolean {

                let checked = true;

                if (  mode.value === "change" && !isAdminMode && (!passwordRef.data.kennwort || passwordRef.data.kennwort.length < 1)) {
                    checked = false;
                }
                if ( !passwordRef.data.kennwortNeu || passwordRef.data.kennwortNeu.length < 1) {
                    checked = false;
                }
                if ( !passwordRef.data.kennwortVergleich || passwordRef.data.kennwortVergleich.length < 1) {
                    checked = false;
                }

                if( !checked) {
                    const errorState = ErrorStateServiceForRoot.getErrorStateService()                                  
                    errorState.changeErrorState(CreateUserError("Benutzer.Save" , "Die Kennwortdaten sind unvollständig."))                
                    return false;
                }

                if( passwordRef.data.kennwortNeu !== passwordRef.data.kennwortVergleich) {
                    const errorState = ErrorStateServiceForRoot.getErrorStateService()                                  
                    errorState.changeErrorState(CreateUserError("Benutzer.Save" , "Die Kennwörter stimmen nicht überein."))                
                    return false;
                }

                if ( !validatePasswordRules(passwordRef.data.kennwortNeu ?? "")) {
                    const errorState = ErrorStateServiceForRoot.getErrorStateService()                                  
                    errorState.changeErrorState(CreateUserError("Benutzer.Save" , "Das Kennwort entspricht nicht den Anforderungen."))                
                    return false;
                }


                return true;
            }

            function validatePasswordRules(kennwort: string) : boolean {
                const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&_?\-*])[a-zA-Z\d!@#$%^&_?\-*]{8,}$/;                
                if (!regex.test(kennwort)) 
                    return false
                return true;
            }

            async function savePassword() : Promise<boolean> {

                const kennwortVerwaltung = new KennwortVerwaltung();
                
                if ( mode.value === "new") {
                    const result =  await kennwortVerwaltung.newPassword(passwordRef.data);
                    if( !result) return false;
                    cleanUpPassword(true)
                    emit("passwordChanged", true);
                    return true;
                }

                if (isAdminMode.value) {
                    const result =  await kennwortVerwaltung.changePasswordByAdmin(passwordRef.data);
                    if( !result) return false;
                    cleanUpPassword(true)
                    emit("passwordChanged", true);
                    return true;
                }

                const result =  await kennwortVerwaltung.changePassword(passwordRef.data);
                if( !result) return false;
                cleanUpPassword(true)
                emit("passwordChanged", true);
                return true;

                
            }



            function cancelPassword() {
                cleanUpPassword(false);
                emit("passwordChanged", false);
            }


            function cleanUpPassword(isSaved: boolean) {
                isVisible.value = false;
                passwordRef.data.kennwort = "";
                passwordRef.data.kennwortNeu = "";
                passwordRef.data.kennwortVergleich = "";
            }

            function getPasswordTitle() : string {
                if ( mode.value === "new") {
                    return "Neues Kennwort anlegen";
                }
                return "Kennwort ändern";
            }

            watch(() => props.isAdminMode,(idAdminModeParam: boolean) => {    
                isAdminMode.value = idAdminModeParam;                
            }, {deep: true});

            watch(() => props.idPerson,(idPersonParam: number) => {    
                idPerson.value = idPersonParam;
                passwordRef.data.id = idPersonParam;
            }, {deep: true});

            watch(() => props.isVisible,(visible: boolean) => {    
                isVisible.value = visible;
            }, {deep: true});

            watch(() => props.refresh,(refresh: Date) => {    
                isVisible.value = props.isVisible;
            }, {deep: true});

            watch(() => props.className,(className: string) => {    
                if (className === "dialog__wrapper") {
                    backdropName.value = "backdrop";
                } else {
                    backdropName.value = "backdrop-none";
                }
            }, {deep: true});

            watch(() => props.mode,(modeProp: string) => {    
                mode.value = modeProp;
            }, {deep: true});

            return {
                isVisible,
                onPasswordCancel,
                onPasswordChange,
                wrapperName,
                backdropName,
                idPerson,
                passwordRef,
                mode,
                getPasswordTitle,
                isAdminMode
            }
        }
    })
</script>

<style scoped lang="scss">
    .backdrop {
        backdrop-filter: blur(20px)  grayscale(10%) ;
        outline: 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
    }

    .backdrop-none {
        outline: 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        background-color: rgb(255, 255, 255);
    }

    .dialog__wrapper {
        backdrop-filter: blur(20px)  grayscale(10%) ;
        outline: 0;
        position: fixed;
        top: 100px;
        left: 50%;	
        z-index: 10001;
        min-width: 400px;
        width: 400px;
        min-height: 380px;
        height: 380px;
        border-style: solid;
        box-sizing: border-box;
        border-width: 1px!important;  
        border-color: #cfcfcf !important;
    }

    .form__wrapper {
        outline: 0;
        position: fixed;
        top: 100px;
        left: 200px;
        border-style: solid;
        box-sizing: border-box;
        max-width: 400px;
        border-width: 1px!important;  
        border-color: #cfcfcf !important;
    }

    .wrapper__content {
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
        border: none;
    }
</style>